import { useState, useEffect } from 'react';
import { projectFirestore } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

const usePosts = (props = {}) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    let cancelled = false;

    async function fetchPosts() {
      setLoading(true);
      setError(null);

      try {
        let uid = props.profileUid;

        if (!uid) {
          if (props.username) {
            const userSnap = await projectFirestore
              .collection('usernames')
              .doc(props.username)
              .get();

            if (cancelled) return;

            if (!userSnap.exists) {
              setPosts([]);
              setLoading(false);
              return;
            }
            uid = userSnap.data().uid;
          } else if (currentUser) {
            uid = currentUser.uid;
          }
        }

        if (!uid) {
          setPosts([]);
          setLoading(false);
          return;
        }

        const snapshot = await projectFirestore
          .collection('posts')
          .doc(uid)
          .collection('allPosts')
          .orderBy('createdAt', 'desc')
          .get();

        if (cancelled) return;

        setPosts(snapshot.docs.map((doc) => doc.data()));
      } catch (err) {
        if (cancelled) return;
        console.error('usePosts:', err);
        setError(err.message || 'Failed to load posts');
        setPosts([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchPosts();

    return () => {
      cancelled = true;
    };
  }, [props.updated, props.username, props.profileUid, currentUser]);

  return { posts, loading, error };
};

export default usePosts;
